import React, { useMemo } from "react";
import {
  Box,
  Chip,
  Checkbox,
  TextField,
  FormControl,
  Autocomplete,
} from "@mui/material";
import { Clear } from "@mui/icons-material";

const DeviceGroupInputForm = ({ formikProps, selectorsData }) => {
  const { values, errors, touched, setFieldValue, setFieldTouched } =
    formikProps;

  const deviceOptions = useMemo(
    () =>
      selectorsData?.devices?.filter(Boolean)?.map((device) => ({
        ...device,
        label: device?.modelDisplayName,
      })) || [],
    [selectorsData]
  );

  return (
    <form>
      <div style={{ margin: "2% 0" }}>
        <FormControl style={{ width: "100%" }}>
          <TextField
            id="name"
            name="name"
            label="Device Group Name"
            variant="outlined"
            required
            error={touched.name && !!errors.name}
            helperText={touched.name && errors.name}
            style={{ width: "100%" }}
            defaultValue={values?.name}
            onChange={(e) => {
              setFieldTouched("name");
              setFieldValue("name", e.target.value);
            }}
          />
        </FormControl>
      </div>
      <div className="d-flex justify-end align-items-end">
        <a
          href="/settings/devices"
          className="profile-edit-button"
          target="_blank"
          style={{ marginTop: "20px", textDecoration: "none" }}
        >
          Need help to add new devices?
        </a>
      </div>
      <div style={{ margin: "2% 0" }}>
        <FormControl style={{ width: "100%" }}>
          <Autocomplete
            multiple
            id="devices"
            name="devices"
            disablePortal
            disableClearable
            disableCloseOnSelect
            freeSolo={false}
            value={values?.devices || []}
            options={deviceOptions || []}
            onChange={(e, selectedDevices) => {
              setFieldTouched("devices");

              // Extract selected `_id`s from the Autocomplete selections
              const selectedIds = selectedDevices.map((device) => device?._id);

              // Toggle behavior: If already selected, remove it; otherwise, add it
              const updatedDevices = values.devices.includes(
                selectedIds[selectedIds.length - 1]
              )
                ? values.devices.filter(
                    (id) => id !== selectedIds[selectedIds.length - 1]
                  )
                : [...values.devices, selectedIds[selectedIds.length - 1]];

              setFieldValue("devices", updatedDevices);
            }}
            ListboxProps={{ style: { maxHeight: "200px", overflowY: "auto" } }}
            getOptionLabel={(option) => option.label || ""}
            renderTags={(value, getTagProps) => (
              <Box
                className="d-flex flex-wrap"
                sx={{ maxHeight: "240px", overflowY: "auto" }}
              >
                {value?.map((deviceId, index) => {
                  const device = deviceOptions.find(
                    (device) => device?._id === deviceId
                  );
                  return (
                    <Chip
                      {...getTagProps({ index })}
                      key={deviceId}
                      label={device?.label}
                      variant="outlined"
                      deleteIcon={<Clear />}
                      onDelete={() => {
                        const updatedDevices = values.devices.filter(
                          (selectedId) => selectedId !== deviceId
                        );
                        setFieldValue("devices", updatedDevices);
                      }}
                    />
                  );
                })}
              </Box>
            )}
            renderOption={(props, option, { selected }) => {
              const { key, ...optionProps } = props;
              return (
                <li key={key} {...optionProps}>
                  <Checkbox checked={values?.devices?.includes(option?._id)} />
                  {option?.label}
                </li>
              );
            }}
            style={{ width: "100%", marginBottom: "2%" }}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Devices"
                variant="outlined"
                placeholder="Search Device"
                required
                error={touched.devices && Boolean(errors.devices)}
                helperText={touched.devices && errors.devices}
              />
            )}
          />
        </FormControl>
      </div>
    </form>
  );
};

export default DeviceGroupInputForm;
